import { type JSX, Show } from 'solid-js';
import type { CardView } from '../../lib/machine-card';
import { CardAction } from './CardAction';
import { LiveReason } from './LiveReason';
import { StateMark } from './StateMark';

// The loud states' tinted banner (#6785, prototype `banner`, `:2077-2080`): Paused,
// Blocked, Needs you and Offline. The label with its mark, the action, and the reason on
// its own row; a loud card's footer then drops both. A status region: it is what changed.

export function CardBanner(props: {
  readonly view: CardView;
  readonly onAction: () => void;
}): JSX.Element {
  return (
    <div class="mission-card__banner" data-tone={props.view.tone} role="status">
      <span class="mission-card__banner-label">
        <StateMark state={props.view.state} />
        {props.view.label}
      </span>
      <Show when={props.view.action}>
        {(label) => (
          <CardAction
            label={label()}
            tone={props.view.tone}
            size="banner"
            onPress={props.onAction}
          />
        )}
      </Show>
      <LiveReason
        class="mission-card__banner-reason"
        reason={props.view.reason}
        liveReason={props.view.liveReason}
      />
    </div>
  );
}
